import React from 'react';

export default function Disclaimer() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-3xl mx-auto bg-white p-6 sm:p-10 shadow-sm border border-gray-200">
        
        {/* Page Header */}
        <div className="border-b border-gray-200 pb-6 mb-8 text-center sm:text-left">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
            Disclaimer
          </h1>
          <p className="text-xs sm:text-sm text-gray-500 mt-2">
            Last Updated: {new Date().toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}
          </p>
        </div>

        {/* Introduction */}
        <p className="text-sm text-gray-600 leading-relaxed mb-8">
          Please be advised that accessing or utilizing the landing page implies the user's consent to abide by the following terms and conditions:
        </p>

        {/* Policy Sections */}
        <div className="space-y-6">
          
          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Intellectual Property
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              All content, images, logos, and other materials on this landing page are the property of respective project developer or its licensors. These properties are safeguarded by intellectual property laws, and users are expressly prohibited from copying, altering, distributing, or utilizing any content without obtaining prior written permission.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Property Information
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              This landing page's content, which includes details of the properties, costs, and availability, is subject to change at any time. The Company is not responsible for any inaccuracies or omissions in the information provided.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              User Obligations
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Users are obligated to furnish accurate and current information when submitting inquiries or requests via the landing page. Additionally, users must commit to refraining from engaging in any unlawful or harmful activities, such as hacking, spamming, or transmitting malicious software.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Disclaimer of Liability
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              The Company explicitly disclaims liability for any damages, losses, or injuries arising from the use of the landing page or reliance on the provided information. This disclaimer extends to encompass, but is not limited to, financial losses, property damage, or any other direct or indirect damages.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Links to Third-Party Websites
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              This landing page may contain links to external websites or resources. We do not endorse or assume responsibility for the content, privacy practices, or availability of those third-party sites.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Modifications to the Terms
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              The Company may update or modify these terms and conditions at any time without prior notice. We encourage you to review these terms periodically to stay informed about any changes.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Governing Law and Jurisdiction
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Any legal disputes arising from your use of this landing page will be governed by the laws of the State of Maharashtra and will be resolved in the courts of Mumbai.
            </p>
          </section>

        </div>

        {/* Back Button / Footer Link */}
        <div className="mt-10 pt-6 border-t border-gray-200 text-center">
          <a 
            href="/" 
            className="text-xs sm:text-sm text-[#007BFF] hover:underline font-medium"
          >
            ← Back to Homepage
          </a>
        </div>

      </div>
    </div>
  );
}